/* @flow */

export const NIVEL_MASTER = 'M';
export const NIVEL_SUPORTE = 'S';
export const NIVEL_ADMIN = 'A';
export const NIVEL_FUNCIONARIO = 'F';
export const NIVEL_CLIENTE = 'C';

export const NOME_CONTATO_RESIDENCIAL = 'Residencial';
export const NOME_CONTATO_CELULAR = 'Celular';
export const NOME_CONTATO_COMERCIAL = 'Comercial';
